module.exports = __webpack_public_path__ + "img/arrow-3-education-x-template 1.0dc2630b.svg";